import clsx from 'clsx'
import { useState } from 'react'
import { ArrowDownIcon } from '@/assets/icons/arrow-down-icon'
import { ArrowUpIcon } from '@/assets/icons/arrow-up-icon'
import { Show } from '@/components/show'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export interface ButtonOptionsItems {
  label: string
  textColor: string
  active: boolean
  action?: () => void
  state?: 'enabled' | 'disabled' | 'blocked'
}

interface ButtonOptionsProps {
  label: string
  items: ButtonOptionsItems[]
  disabled?: boolean
}

export const ButtonOptions = ({
  label,
  items,
  disabled
}: ButtonOptionsProps) => {
  const [open, setOpen] = useState(false)

  const chooseArrow = () => {
    return open ? <ArrowUpIcon /> : <ArrowDownIcon />
  }

  const handleAction = (element: ButtonOptionsItems) => {
    if (element.action) {
      element.action()
      setOpen(false)
    }
  }

  return (
    <div className="relative w-38">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        disabled={disabled || false}
        className={clsx(
          'w-full rounded-lg text-background h-12 flex gap-3 items-center justify-center',
          { 'rounded-lg': !open },
          { 'rounded-bl-none rounded-br-none': open },
          { 'bg-[var(--brand-blue-2)]/30': disabled },
          { 'bg-[var(--brand-blue-2)]': !disabled }
        )}
      >
        {label}
        {chooseArrow()}
      </button>
      <Show when={open}>
        <div className="w-full absolute text-center bg-background rounded-b-lg overflow-hidden border border-[var(--brand-blue-3)]">
          {items.map((element, index) => (
            <Button
              type="button"
              key={index}
              disabled={element.active ? element.state === 'disabled' : true}
              variant={'ghost'}
              onClick={() => handleAction(element)}
              className={cn(
                `select-none cursor-pointer border border-t-[var(--brand-blue-3)] ${element.textColor} rounded-none`,
                { 'opacity-50': element.state === 'blocked' }
              )}
            >
              {element.label}
            </Button>
          ))}
        </div>
      </Show>
    </div>
  )
}
